export const EXPLORE_TABS = [
  "image",
  "video",
  "3d",
  "model",
  "texture",
  "skybox",
  "canvas",
] as const;

export type ExploreTabId = (typeof EXPLORE_TABS)[number];
